// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"HireCarInfo-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/HireCarInfo.desktop.scss
 ** module id = 904
 ** module chunks = 1
 **/